/**
 * Generated by orval v6.31.0 🍺
 * Do not edit manually.
 * Stitch Web
 * OpenAPI spec version: 0.0.53
 */

export type ActionItemCategory =
	(typeof ActionItemCategory)[keyof typeof ActionItemCategory];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const ActionItemCategory = {
	Medication_Start: 'Medication_Start',
	Medication_Discontinuation: 'Medication_Discontinuation',
	Medication_Refill: 'Medication_Refill',
	Medication_Details_Change: 'Medication_Details_Change',
	Medication_Continue: 'Medication_Continue',
	Lab_Order: 'Lab_Order',
	Imaging_Order: 'Imaging_Order',
	Medical_Referral: 'Medical_Referral',
	Other_Action: 'Other_Action',
	Document_Review: 'Document_Review',
	Advise_Patient: 'Advise_Patient',
	Take_Note: 'Take_Note',
	Physical_Exam: 'Physical_Exam',
	Symptom_Evaluation: 'Symptom_Evaluation',
} as const;
